module.exports = __webpack_public_path__ + "img/htkj_17.f84c289c.jpg";